import { makeStyles } from '@eagleview/ev-comp-library';

export default makeStyles((theme) => ({
  layoutHeader: {
    display: 'flex',
    flexdirection: 'row',
    fontWeight: '600',
    fontSize: '16px',
    lineHeight: '24px',
    paddingBottom: '5px',
    color: theme.evPalette.charcoal[800],
  },
  imageContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    border: `1px solid ${theme.evPalette.charcoal[400]}`,
    padding: '2px',
    borderRadius: '4px',
  },
  image: {
    maxHeight: '200px',
    display: 'flex',
    maxWidth: '294px',
    margin: 'auto',
    '@media (min-width: 1024px)': {
      maxWidth: '298px',
    },
  },
  linkText: {
    color: theme.evPalette.ocean[600],
  },
  layoutText: {
    maxWidth: '294px',
    lineHeight: '24px',
    paddingTop: '5px',
    '@media (min-width: 1024px)': {
      maxWidth: '300px',
      fontSize: '15px',
    },
  },
}));
